import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=613b1ee9"
import script from "./GatewayDetails.vue?vue&type=script&lang=js"
export * from "./GatewayDetails.vue?vue&type=script&lang=js"
import style0 from "./GatewayDetails.vue?vue&type=style&index=0&id=613b1ee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports